export default {
    SET_SYSTEMS: (state, systems) => {
        state.systems = systems
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    RESET_FILTERS: (state) => {
        state.filters = {
            fromDate: new Date(+new Date() - 2419200000).toISOString().split('T')[0],
            toDate: null,
            enabled: null,
            wasStartedUp: null,
            finished: null,
            countClientsFrom: null,
            countClientsTo: null,
            totalOrderFrom: null,
            totalOrderTo: null,
            name: null,
            bonusSystem: 'cashbackPercent'
        }
    }
}
